import { render } from "./Layout.vue?vue&type=template&id=5c694edb&scoped=true&bindings={}"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=5c694edb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c694edb"

export default script